import { selectMenu } from './chunk-67X7HZEW.mjs';

// src/helpers/factories/menuTypeVersionsFactory.ts
var menuTypeVersionsFactoryCore = (menuTypeVersions, state) => {
  const currentMenu = selectMenu(state);
  const menuTypes = currentMenu.menuTypes;
  const menuTypesIds = Object.values(menuTypeVersions).map(
    (MenuTypeVersion) => MenuTypeVersion.menuTypeId
  );
  return Object.values(menuTypes).filter(
    (menuType) => menuTypesIds.includes(menuType.id)
  );
};
var menuTypeVersionsSelectionFactoryCore = (menuTypeVersions, state) => {
  const currentMenu = selectMenu(state);
  const menuTypes = currentMenu.menuTypes;
  const menuTypesIds = Object.values(menuTypeVersions).map(
    (MenuTypeVersion) => MenuTypeVersion.menuTypeId
  );
  return Object.values(menuTypes).filter((menuType) => menuTypesIds.includes(menuType.id) && menuType.active).map((menuTypeVersion) => {
    return {
      name: menuTypeVersion.posName,
      menuTypeId: menuTypeVersion.menuTypeId,
      selected: false
    };
  });
};

export { menuTypeVersionsFactoryCore, menuTypeVersionsSelectionFactoryCore };
